import { POST } from '../endpoints'
import { postData } from '../utils'
import {
  PermutationGenerationRequest,
  PermutationGenerationResponse,
  PermutationRequest,
  PermutationResponse,
} from './types'

export async function requestPermutations(request: PermutationRequest) {
  return postData<PermutationResponse, PermutationRequest>({
    endpoint: POST.dataGenerationPermutations(),
    queryOptions: request,
  })
}

export async function generatePermutations(request: PermutationGenerationRequest) {
  return postData<PermutationGenerationResponse, PermutationGenerationRequest>({
    endpoint: POST.dataGenerationPermutationsGenerate(),
    queryOptions: request,
  })
}
